<template>
  <home-section
    :loading="loading"
    :error="error"
    :is-empty="!items.length"
    :variant="commercial ? 'commercial-banner' : 'banner'"
    skeleton-variant="banners"
    :skeleton-count="2"
    @retry="$emit('retry')"
  >
    <home-banner-rail :items="items" :commercial="commercial" />
  </home-section>
</template>

<script>
import HomeSection from "./HomeSection.vue";
import HomeBannerRail from "@/components/home/rails/HomeBannerRail.vue";

export default {
  name: "HomeBannerSection",
  components: { HomeSection, HomeBannerRail },
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    commercial: { type: Boolean, default: false },
  },
};
</script>
